import React from 'react';

/**
 * Shared section header for side-by-side dashboard panels (Short Actions, Shortcuts, etc.)
 */
function DashboardPanelHeader({ eyebrow, title, subtitle, icon: Icon, className = '' }) {
  return (
    <div className={`mb-3 shrink-0 overflow-visible ${className}`}>
      <p className="micro text-orange-600 ">
        {eyebrow}
      </p>
      <div className="mt-1 flex items-center gap-2 overflow-visible">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center overflow-visible rounded-xl bg-gradient-to-br from-orange-500 to-amber-500 text-white shadow-glow ring-1 ring-white/30">
          <Icon className="h-4 w-4" />
        </span>
        <h3 className="title-line !text-base sm:!text-lg">
          {title}
        </h3>
      </div>
      {subtitle ? (
        <p className="mt-1 line-clamp-2 pl-10 text-xs leading-relaxed text-secondary-500 ">
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}

export default DashboardPanelHeader;
